import { ClaimBookFormComponent } from '../components/layout/claim-book-form/claim-book-form.component';
import { ContactFormComponent } from '../components/layout/contact-form/contact-form.component';
import { Routes } from '@angular/router';

export const formsRoutes: Routes = [
  {
    path: 'complaints-book',
    component: ClaimBookFormComponent,
  },
  {
    path: 'contact-us',
    component: ContactFormComponent,
  },
  {
    path: 'contact-us/:iosContact',
    component: ContactFormComponent,
  },
];
